import { AxiosInstance } from "axios"
import { DeviceSupplierAdmin } from "./supplierAdminTypes"

type AllDevicesForSupplierParams = Readonly<{ supplierId: number }>

export type DevicesSupplierAdminResponse = Readonly<{
    devices: DeviceSupplierAdmin[]
}>

export async function fetchAllDevicesForSupplier(
    { supplierId }: AllDevicesForSupplierParams,
    axios: AxiosInstance,
    signal?: AbortSignal,
): Promise<DevicesSupplierAdminResponse> {
    const { data } = await axios.get(`/suppliers/${supplierId}/devices`, {
        signal,
    })
    return data
}
